<template>
  <div>
    <v-layout>
      <v-flex>
        <h1 class="headline mb-3">Products</h1>
      </v-flex>
      <v-flex class="text-xs-right">
        <v-btn
          :loading="turnoffloading"
          @click="changeallproductstatus(false)"
          outline
          color="grey"
        >hide all product</v-btn>
        <v-btn
          :loading="turnonloading"
          @click="changeallproductstatus(true)"
          outline
          color="grey"
        >show all product</v-btn>
        <div class="form-control" style="display:inline-block">
          <input type="text" class="form-control ma-0" v-model="search" :placeholder="$t('Search')" />
        </div>
      </v-flex>
    </v-layout>
    <div v-if="loading">
      <scale-loader :loading="loading" :color="$vuetify.theme.primary" height="45px" width="7px"></scale-loader>
    </div>
    <div v-else>
      <v-layout wrap>
        <v-flex @click="addproduct" class="pa-1" xs12 sm6 md4 lg3 xl2>
          <div class="btn-add text-xs-center" style="height: 100%;min-height: 350px">
            <v-layout column justify-center align-center style="height: 100%">
              <div>
                <h3 class="headline" style="color:#969595">
                  <i class="fa fa-plus"></i>
                </h3>
                <p>{{ $t('Add new product') }}</p>
              </div>
            </v-layout>
          </div>
        </v-flex>

        <template v-for="(item, k) in filteredProducts">
          <v-flex :key="k" class="pa-1" xs12 sm6 md4 lg3 xl2>
            <v-card style="height: 100%">
              <div>
                <v-responsive :aspect-ratio="1">
                  <div
                    :style="`background-size:contain;background-image: url('${item.photourl?item.photourl:'/static/img/assets/_global/default-photo.png'}');height: 100%;background-position: center;background-size: cover;`"
                  ></div>
                </v-responsive>
              </div>
              <v-card-text style="position: relative">
                <div style="position: absolute; right: 5px; top: -20px;width: 100%">
                  <v-layout row wrap>
                    <v-flex xs6 class="pl-3">
                      <div class="px-2">
                        <label
                          class="toggle-switch small"
                          style="margin-top: 5px;margin-bottom: 10px;vertical-align: bottom;"
                        >
                          <input @input="changeStatus(item)" v-model="item.status" type="checkbox" />
                          <span class="toggle-slider lever round"></span>
                        </label>
                      </div>
                    </v-flex>
                    <v-flex xs6 class="text-xs-right pr-3">
                      <div>
                        <v-btn
                          @click="editProduct(item)"
                          class="ma-1"
                          small
                          icon
                          depressed
                          color="primary"
                        >
                          <span class="fa fa-pencil-alt"></span>
                        </v-btn>
                        <v-btn
                          @click="deleteProduct(item)"
                          class="ma-1"
                          small
                          icon
                          depressed
                          color="primary"
                        >
                          <span class="fa fa-trash"></span>
                        </v-btn>
                      </div>
                    </v-flex>
                  </v-layout>
                </div>
                <div style="word-break: break-word;" class="mt-2">{{item.name}}</div>

                <div
                  v-if="item.productstock&&item.productstock.length"
                  class="primary--text title"
                >{{item.productstock[0][5]}}฿</div>
              </v-card-text>
              <v-divider></v-divider>
              <div>
                <v-card-text style="height: 98px;overflow-y: auto;">
                  <div v-for="stock in item.productstock" :key="stock[0]" class="mb-3">
                    <v-layout row wrap>
                      <v-flex xs6>
                        <div class="primary--text">{{stock[3]|truncate(15)}}</div>
                        <div class="caption">{{stock[1]|truncate(15)}}</div>
                      </v-flex>
                      <v-flex xs6 style="white-space: nowrap;">
                        <v-btn
                          @click="updateQuantity('+',stock,item.id)"
                          small
                          outline
                          fab
                          color="primary"
                          class="extra-small my-0"
                        >
                          <v-icon>add</v-icon>
                        </v-btn>
                        <span class="py-2">{{stock[4]}}</span>
                        <v-btn
                          @click="updateQuantity('-', stock,item.id)"
                          small
                          outline
                          fab
                          class="extra-small my-0"
                          color="primary"
                        >
                          <v-icon>remove</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-card-text>
              </div>
            </v-card>
          </v-flex>
        </template>
        <v-dialog v-model="adddialog" persistent width="950px">
          <v-card>
            <div class="text-xs-right">
              <v-btn @click="close" icon>
                <v-icon>close</v-icon>
              </v-btn>
            </div>
            <v-card-text class="pt-0">
              <h3 class="headline mb-2">Add New Product</h3>

              <div
                style="width: 50%;margin: auto; border-radius: 10px"
                class="form-control mt-3"
                :class="{'has-error': errors.has('photo')}"
              >
                <uploadfile name="photo" :data-vv-as="$t('Photo')" v-model="input.photourl"></uploadfile>
                <span class="text-error" v-if="errors.has('photo')">{{ errors.first('photo') }}</span>
              </div>

              <v-layout row wrap>
                <v-flex xs12>
                  <div class="form-control mt-3" :class="{'has-error': errors.has('name')}">
                    <div class="caption">{{$t('Product Name')}} *</div>
                    <input
                      name="name"
                      :data-vv-as="$t('Product Name')"
                      v-validate="'required'"
                      type="text"
                      v-model="input.name"
                    />
                    <span class="text-error" v-if="errors.has('name')">{{ errors.first('name') }}</span>
                  </div>
                </v-flex>
                <v-flex xs6>
                  <div class="form-control mt-2 pa-1" :class="{'has-error': errors.has('keyword')}">
                    <div class="caption">{{$t('Keyword')}}</div>
                    <input
                      name="keyword"
                      style="text-transform: uppercase;"
                      :data-vv-as="$t('keyword')"
                      type="text"
                      v-model="input.keyword"
                    />
                    <span
                      class="text-error"
                      v-if="errors.has('weight')"
                    >{{ errors.first('weight') }}</span>
                  </div>
                </v-flex>

                <v-flex xs6>
                  <div class="form-control mt-2 pa-1" :class="{'has-error': errors.has('weight')}">
                    <div class="caption">{{$t('Weight')}}</div>
                    <input
                      name="weight"
                      :data-vv-as="$t('weight')"
                      type="number"
                      v-model="input.weight"
                    />
                    <span
                      class="text-error"
                      v-if="errors.has('weight')"
                    >{{ errors.first('weight') }}</span>
                  </div>
                </v-flex>
                <v-flex xs12>
                  <div class="px-2">
                    <div class="caption">ใช้ข้อความตอบกลับที่กำหนดเอง</div>
                    <label
                      class="toggle-switch small"
                      style="margin-top: 5px;margin-bottom: 10px;vertical-align: bottom;"
                    >
                      <input
                        @input="changeStatusMessage(input.templateresponsestatus)"
                        v-model="input.templateresponsestatus"
                        type="checkbox"
                      />
                      <span class="toggle-slider lever round"></span>
                    </label>
                  </div>
                </v-flex>
                <v-flex v-if="input.templateresponsestatus">
                  <message-pattern
                    @onSavePattern="onSavePattern"
                    :pattern="input.templateresponse"
                    :isProducts="true"
                  ></message-pattern>
                </v-flex>
              </v-layout>
              <div>
                <ProductStock
                  :duplicate.sync="duplicate"
                  v-model="productstock"
                  :products="products"
                  :productskey="input.id"
                  @deleteStock="deleteStock"
                ></ProductStock>
              </div>
              <div class="text-xs-center">
                <v-btn @click="close" color="grey" outline>{{$t('cancel')}}</v-btn>
                <v-btn
                  @click="savedata"
                  :loading="saveloading"
                  color="primary"
                  depressed
                >{{$t('save')}}</v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-layout>
    </div>
  </div>
</template>

<script>
import uploadfile from '@/components/elements/uploadfile'
import api from '@/api'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import { mapGetters } from 'vuex'
import ProductStock from './ProductStock'
import MessagePattern from './MessagePattern'

export default {
  components: {
    uploadfile,
    ScaleLoader,
    ProductStock,
    MessagePattern
  },
  provide() {
    return { parentValidator: this.$validator }
  },
  data() {
    return {
      search: '',
      productstock: [],
      stock_process_count: 0,
      deleteStockList: [],
      productid: '',
      turnonloading: false,
      turnoffloading: false,
      autoReply: true,
      products: [],
      saveloading: false,
      duplicate: [],
      input: {
        name: '',
        price: 0,
        templateresponsestatus: false,
        templateresponse: '',
        photourl: '',
        sku: '',
        option: '',
        quantity: 0,
        keyword: '',
        status: true,
        weight: 0
      },
      loading: true,
      adddialog: false
    }
  },
  computed: {
    filteredProducts() {
      var products = { ...this.products }
      if (this.search) {
        products = this.products.filter(el => {
          return el.name.includes(this.search) || el.option.includes(this.search)
        })
      }
      return products
    },
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    this.getProductLive()
  },
  methods: {
    changeStatusMessage() {},
    onSavePattern(val) {
      this.input.templateresponse = JSON.stringify(val)
    },
    saveStock(productid, newproduct) {
      var vm = this
      return new Promise((resolve, reject) => {
        vm.stock_process_count = vm.productstock.length + vm.deleteStockList.length
        let curprod = vm.products.find(el => {
          return el.id == productid
        })
        let curprodindex = vm.products.findIndex(el => {
          return el.id == productid
        })
        this.productstock.forEach((value, i) => {
          let stock = {
            id: value[0],
            option: value[1],
            sku: value[2],
            keyword: value[3],
            quantity: value[4],
            price: value[5],
            discountprice: value[6],
            productid: productid ? productid : '',
            pageid: vm.selectedBot.pageid
          }
          if (value[0] == null || value[0] == undefined) {
            api.postproductstocklive(stock, (err, response) => {
              vm.stock_process_count--
              if (response && response.data) {
                vm.productstock[i][0] = response.data[0].id
                if (!newproduct) {
                  curprod.productstock.push([...value])
                }
                if (vm.stock_process_count == 0) {
                  resolve(curprodindex)
                }
              } else if (response.reason) {
                vm.duplicate.push(stock.keyword)
                if (vm.stock_process_count == 0) {
                  resolve(curprodindex)
                }
              }
            })
          } else {
            api.putproductstocklive(stock, (err, response) => {
              vm.stock_process_count--
              if (response && response.data) {
                curprod.productstock[i] = [...value]
                if (vm.stock_process_count == 0) {
                  resolve(curprodindex)
                }
              } else if (response.reason) {
                vm.duplicate.push(stock.keyword)
                if (vm.stock_process_count == 0) {
                  resolve(curprodindex)
                }
              }
            })
          }
        })
        vm.deleteStockList.forEach((val, index) => {
          api.deleteproductstocklive({ id: val, pageid: vm.selectedBot.pageid }, function(
            error,
            response
          ) {
            if (error) {
              console.error(error)
            }
            var k = curprod.productstock.findIndex(el => el[0] == val)
            curprod.productstock.splice(k, 1)
            vm.stock_process_count--
            if (vm.stock_process_count == 0) {
              resolve(curprodindex)
            }
          })
        })
      })
    },
    stopLoading() {
      var vm = this
      vm.saveloading = false

      vm.adddialog = false
      vm.input = {
        name: '',
        price: 0,
        photourl: '',
        sku: '',
        option: '',
        quantity: 0,
        keyword: '',
        weight: 0,
        templateresponse: '',
        templateresponsestatus: false
      }
      vm.duplicate = []
    },
    deleteStock: function(id) {
      this.deleteStockList.push(id)
    },
    changeallproductstatus(type) {
      if (type) {
        this.turnonloading = true
      } else {
        this.turnoffloading = true
      }
      api.putchangeproductlivestatus(
        { pageid: this.selectedBot.pageid, status: type },
        (err, response) => {
          this.turnonloading = false
          this.turnoffloading = false
          this.products.forEach((el, i) => {
            this.products[i].status = type
          })
        }
      )
    },
    editProduct(item) {
      this.input = { ...item }
      this.productstock = JSON.parse(JSON.stringify(item.productstock))
      this.adddialog = true
    },
    deleteProduct(item) {
      var vm = this
      this.$swal
        .fire({
          text: this.$t('Do you want to delete {name}?', { name: item.name.replace(/\<|\>/g, '') }),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            api.deleteproductlive(
              { pageid: this.selectedBot.pageid, id: item.id },
              (err, response) => {
                this.products.splice(
                  this.products.findIndex(el => el.id == item.id),
                  1
                )
              }
            )
          }
        })
    },
    savedata() {
      var vm = this

      vm.$validator.validateAll().then(result => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        } else if (result) {
          vm.saveloading = true
          if (vm.input.id) {
            api.putproductlive(
              { pageid: this.selectedBot.pageid, ...vm.input, weight: parseFloat(vm.input.weight) },
              async (err, response) => {
                if (response.responsecode == 200) {
                  var currentproductindex = await vm.saveStock(response.data[0].id)
                  if (vm.duplicate.length) {
                    vm.products.splice(currentproductindex, 1)
                    return (vm.saveloading = false)
                  } else {
                    var index = vm.products.findIndex(el => el.id == vm.input.id)
                    vm.$set(vm.products, index, vm.input)
                    vm.stopLoading()
                  }

                  this.$nextTick(() => {
                    this.errors.clear()
                    this.$nextTick(() => {
                      this.$validator.reset()
                    })
                  })
                  // vm.adddialog = false
                  // vm.saveloading = false
                }
              }
            )
          } else {
            api.postproductlive(
              {
                pageid: this.selectedBot.pageid,
                ...vm.input,
                status: true,
                weight: parseFloat(vm.input.weight)
              },
              async (err, response) => {
                if (response.responsecode == 200) {
                  vm.products.push({
                    id: response.data[0].id,
                    ...vm.input,
                    productstock: this.productstock,
                    status: true
                  })
                  var currentproductindex = await vm.saveStock(response.data[0].id, true)
                  if (vm.duplicate.length) {
                    vm.products.splice(currentproductindex, 1)
                    return (vm.saveloading = false)
                  } else {
                    vm.stopLoading()
                  }
                  this.$nextTick(() => {
                    this.errors.clear()
                    this.$nextTick(() => {
                      this.$validator.reset()
                    })
                  })
                  // vm.adddialog = false
                  // vm.saveloading = false
                }
              }
            )
          }
        }
      })
    },
    close() {
      this.adddialog = false
      this.duplicate = []
    },
    updateQuantity(op, item, id) {
      var vm = this
      var data = JSON.parse(JSON.stringify(item))
      if (op == '+') {
        data[4] = parseFloat(data[4])
        data[4]++
      } else if (op == '-') {
        data[4] = parseFloat(data[4])
        data[4]--
      }

      let stock = {
        id: data[0],
        option: data[1],
        sku: data[2],
        keyword: data[3],
        quantity: data[4],
        price: data[5]
      }
      api.putproductstocklive({ pageid: this.selectedBot.pageid, ...stock }, (err, response) => {
        var products = vm.products[vm.products.findIndex(el => el.id == id)]
        var curstock =
          products.productstock[products.productstock.findIndex(el => el[0] == item[0])]
        if (response.responsecode == 200) {
          if (op == '+') {
            vm.$nextTick(() => {
              curstock[4] = parseFloat(item[4])
              curstock[4]++
              vm.$forceUpdate()
            })
          } else if (op == '-') {
            curstock[4] = parseFloat(item[4])
            curstock[4]--
            vm.$forceUpdate()
          }
        }
      })
    },
    changeStatus(item) {
      item.status = !item.status
      api.putproductlive({ pageid: this.selectedBot.pageid, ...item }, (err, response) => {
        if (response.responsecode == 200) {
        }
      })
    },
    getProductLive() {
      this.loading = true
      api.getproductlive({ pageid: this.selectedBot.pageid }, (err, response) => {
        this.loading = false
        if (response.responsecode == 200 && response.data) {
          this.products = response.data
        }
      })
    },
    addproduct() {
      this.input = {
        name: '',
        price: 0,
        photourl: '',
        sku: '',
        option: '',
        quantity: '',
        keyword: '',
        templateresponsestatus: false,
        templateresponse: ''
      }
      this.productstock = [[null, null, null, null, null, null]]
      this.$nextTick(() => {
        this.errors.clear()
        this.$nextTick(() => {
          this.$validator.reset()
        })
      })
      this.adddialog = true
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/live/Products.vue